import BottomStickyBlock from '@r1-frontend/ui-react/components/BottomStickyBlock';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { BlockContainer } from '@r1-frontend/ui-react/experimental/containers';
import BaseOrderSummary from '@r1-frontend/ui-react/organisms/OrderSummary';
import OrderSummaryItem from '@r1-frontend/ui-react/organisms/OrderSummary/Item';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import { useContextSelector } from '~/src/entities/speed-bonus/context/hooks';
import { isShowSummary, selectSummaryInfo } from '~/src/entities/speed-bonus/context/selectors';

const SummaryInfo = (): JSX.Element | null => {
    const isLaptop = useMatchMediaByWidth(wideBreakpoints.laptop);

    const { isSummaryVisible, summaryInfo } = useContextSelector(state => ({
        isSummaryVisible: isShowSummary(state),
        summaryInfo: selectSummaryInfo(state),
    }));

    if (!isSummaryVisible || !summaryInfo) {
        return null;
    }

    return (
        <>{isLaptop
            ? <BottomStickyBlock
                InnerComponent={() => (
                    <BaseOrderSummary {...summaryInfo}/>
                )}
                OuterComponent={() => (
                    <OrderSummaryItem
                        Component={H4}
                        title={'Итого:'}
                        cost={summaryInfo.total}
                        isMonthly={false}
                    />
                )}
            />
            : <BlockContainer indent={{ $mobile: [24], $desktop: [24] }} rounder={{ $radius: 32 }} style={{ alignSelf: 'flex-start' }}>
                <BaseOrderSummary {...summaryInfo}/>
            </BlockContainer>
        }</>
    );
};

export default SummaryInfo;
